import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions
} from '@angular/router';

import { DropdownModule, SidebarModule } from '@coreui/angular';
import { IconSetService } from '@coreui/icons-angular';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiKeyInterceptor } from './utils/interceptors/api-key.interceptor';
import { apiAuthInterceptor } from './utils/interceptors/api-auth.interceptor';
import { applicationIdInterceptor } from './utils/interceptors/application-id.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
      withHashLocation()
    ),
    provideHttpClient(withInterceptors([apiKeyInterceptor, apiAuthInterceptor, applicationIdInterceptor])),
importProvidersFrom(SidebarModule, DropdownModule),
    provideAnimations(),

    importProvidersFrom(ModalModule.forRoot()),
    importProvidersFrom(TabsModule.forRoot()),

    IconSetService,
    BrowserModule,
  ]
};

